import * as moment from 'moment';

const isExpired = (authData: { expirationDate?: string }, log: boolean = false) => {
  const expDate = moment(authData.expirationDate);
  const limitDate = moment().add(10, 's');
  const result = expDate.isBefore(limitDate);
  if (log) {
    console.debug(`Expiration date: ${expDate.toISOString()}, limit date: ${limitDate.toISOString()}, isExpired: ${result}`);
  }
  return result;
};

export default isExpired;
